// Cubitt: fachada de YouTube; el iframe (y todo YouTube) solo se carga al pulsar la miniatura.
if (!customElements.get('youtube-facade')) {
  customElements.define('youtube-facade', class extends HTMLElement {
    connectedCallback() {
      this.querySelector('.youtube-facade__link')?.addEventListener('click', (event) => {
        // Cubitt: Ctrl/Cmd/Shift + clic sigue abriendo YouTube en otra pestaña.
        if (this.activated || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        this.activate();
      });
    }

    activate() {
      this.activated = true;
      const iframe = document.createElement('iframe');
      iframe.src = this.dataset.src;
      iframe.title = this.dataset.title || 'YouTube video player';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      this.replaceChildren(iframe);
      iframe.focus();
    }
  });
}
